/* eslint-disable complexity */
import {
  Benefit,
  Normalize,
} from '../typings/normalize';

const normalize = (benefit: Benefit): Normalize => {
  if (!benefit) return null;

  const layoutType = benefit.layoutType;
  const learnMoreCtaLink = benefit.summary?.layout?.[layoutType]?.callToAction?.LEARNMORE?.link;
  const learnMoreLabel = benefit.summary?.layout?.[layoutType]?.callToAction?.LEARNMORE?.label;
  const enrollCtaLink = benefit.summary?.layout?.[layoutType]?.callToAction?.ENROLL?.link;
  const externalCtaLink = benefit.summary?.layout?.[layoutType].callToAction?.OTHER?.link;
  const status = benefit.summary?.layout?.[layoutType]?.showStatus;
  const statusDescripition = status?.description;
  const shouldShowInclude = status?.show;
  const statusInclude = shouldShowInclude && status?.include ? status.include : '';

  const detailLearnMoreCtaLink = benefit.details?.layout?.[layoutType]?.callToAction?.LEARNMORE?.link;
  const detailEnrollCtaLink = benefit.details?.layout?.[layoutType]?.callToAction?.ENROLL?.link;
  const detailExternalCtaLink = benefit.details?.layout?.[layoutType].callToAction?.OTHER?.link;
  const detailStatus = benefit.details?.layout?.[layoutType]?.showStatus;
  const detailStatusDescription = detailStatus?.description;
  const detailShouldShowInclude = detailStatus?.show;
  const detailStatusInclude = detailShouldShowInclude && detailStatus?.include ? detailStatus.include : '';
  const rejected = benefit?.enrollmentApplication?.rejectMessage;
  let finalLearnMoreCtaLink = '';
  let finalEnrollCtaLink = '';

  if (learnMoreCtaLink?.startsWith('http')) {
    finalLearnMoreCtaLink = learnMoreCtaLink;
  } else {
    finalLearnMoreCtaLink = learnMoreCtaLink && `/card-benefits/${learnMoreCtaLink}`;
  }

  if (enrollCtaLink?.startsWith('http')) {
    finalEnrollCtaLink = enrollCtaLink;
  } else {
    finalEnrollCtaLink = enrollCtaLink && `/card-benefits/${enrollCtaLink}`;
  }
  const benefitData = {
    name: benefit.benefitName,
    title: benefit.benefitTitle,
    shortTitle: benefit.benefitShortTitle,
    detailRequiresLogin: benefit?.detailRequiresLogin,
    enrollment: {
      enrollType: benefit?.enrollment?.enrollType,
    },
    layoutType,
    benefitFeatureLabel: benefit?.benefitFeatureLabel,
    summary: {
      copy: benefit.summary?.marketingText?.copy,
      image: benefit.summary?.marketingText?.imageUrl,
      disclaimer: benefit.summary?.marketingText?.disclaimer,
      learnMoreCTA: { // allow both relative path and absolute path
        enabled: !!learnMoreLabel,
        label: learnMoreLabel,
        link: finalLearnMoreCtaLink,
      },
      enrollCTA: { // allow both relative path and absolute path
        enabled: !!enrollCtaLink,
        label: benefit.summary?.layout?.[layoutType]?.callToAction?.ENROLL?.label,
        link: finalEnrollCtaLink,
      },
      externalCTA: { // absolute path
        enabled: !!externalCtaLink,
        label: benefit.summary?.layout?.[layoutType]?.callToAction?.OTHER?.label,
        link: externalCtaLink,
      },
      status: {
        enabled: !!statusDescripition,
        label: statusDescripition + statusInclude,
        enrollmentApplication: {
          status: benefit.enrollmentApplication?.enrollmentStatus.toLowerCase(),
        },
      },
    },
    detail: {
      marketingText: benefit.details?.marketingText,
      copy: benefit.details?.marketingText?.copy,
      image: benefit.details?.marketingText?.imageUrl,
      learnMoreCTA: { // relative path
        enabled: !!detailLearnMoreCtaLink,
        label: benefit.details?.layout?.[layoutType]?.callToAction?.LEARNMORE?.label ? benefit.details?.layout?.[layoutType]?.callToAction?.LEARNMORE?.label : ' ',
        link: detailLearnMoreCtaLink && `/card-benefits/${detailLearnMoreCtaLink}`,
      },
      enrollCTA: { // relative path
        enabled: !!detailEnrollCtaLink,
        label: benefit.details?.layout?.[layoutType]?.callToAction?.ENROLL?.label ? benefit.details?.layout?.[layoutType]?.callToAction?.ENROLL?.label : ' ',
        link: detailEnrollCtaLink?.startsWith('http') ? detailEnrollCtaLink : detailEnrollCtaLink && `/card-benefits/${detailEnrollCtaLink}`,
      },
      externalCTA: { // absolute path
        enabled: Boolean(!!detailExternalCtaLink || detailExternalCtaLink === 'OTHER'),
        label: benefit.details?.layout?.[layoutType]?.callToAction?.OTHER?.label ? benefit.details?.layout?.[layoutType]?.callToAction?.OTHER?.label : ' ',
        link: detailExternalCtaLink,
      },
      status: {
        enabled: !!detailStatusDescription,
        label: detailStatusDescription + detailStatusInclude,
        enrollmentApplication: {
          status: benefit.enrollmentApplication?.enrollmentStatus.toLowerCase(),
          rejectedMessage: rejected,
        },
      },
    },
    disclosures: typeof benefit?.disclosures === 'object' ? benefit?.disclosures : null,
  };
  return benefitData;
};

export default normalize;
